module.exports = __webpack_public_path__ + "static/media/smog.487ef103.svg";